<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    title="Add Pipes"
    submit-name="Add"
    full-height
    @submit="submit"
    @modal-closed="modalClosed"
  >
    <lm-actor-select
      ref="actorSelect"
      :selected-actor="selectedActor"
      check-rights
    >
      Add pipes to:
    </lm-actor-select>
    <lm-pipes-list ref="pipesList" :pipes="pipes" />

    <!-- <lm-tags-selector
      ref="tagSelector"
      class="mb-16"
      :options="currentLandscape.tags"
    /> -->
  </form-modal>
</template>

<script type="text/babel">
import LmActorSelect from '@/components/form/LmActorSelect'
import {mapGetters} from 'vuex'
import {Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import FormHelper from '@/components/form/formHelper'
// import LmTagsSelector from '@/components/form/LmTagsSelector'
import LmPipesList from '@/components/form/LmPipesList'

export default {
  name: 'ModalNewFeedPipe',
  components: {
    LmActorSelect,
    LmPipesList,
    // LmTagsSelector,
    FormModal
  },
  data() {
    return {
      modalName: Modal.NEW_FEED_PIPE,
      modalRef: null,
      inputs: null,
      tags: []
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape', 'pipes'])
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [
      this.$refs.actorSelect,
      this.$refs.pipesList
      // , this.$refs.tagSelector
    ]
    this.$store.dispatch('loadPipes')
  },

  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        let payload = {
          actorId: this.$refs.actorSelect.data,
          pipeId: this.$refs.pipesList.data.pipeId,
          subPipeId: this.$refs.pipesList.data._id
        }
        this.$store
          .dispatch('addPipes', payload)
          .then(() => {
            this.$store.dispatch('loadSources', {force: true}).then(() => {
              this.modalRef.submitSuccess(500)
            })
          })
          .catch(error => {
            this.showUrlError()
            this.modalRef.submitFails(error.devMessage)
          })
      } else {
        this.modalRef.submitFails()
      }
    },
    close() {
      this.modalRef.close()
    },
    modalClosed({reset}) {
      if (reset) {
        FormHelper.reset(this.inputs)
      }
    }
  }
}
</script>
